import ApiRequest from 'core-api';
import Cookies from 'js-cookie';
import { ACCESS_TOKEN_KEY } from 'src/constants/auth';
import { API_ADDRESS } from 'src/enums/apiInfo';
import { RoutePath } from 'src/router/routePath';
import { OPTION_TOOLS_ENABLED } from 'src/config/features';

export const apiRequest = new ApiRequest({
  baseUrl: API_ADDRESS,
  onUnauthenticated: () => {
    Cookies.remove(ACCESS_TOKEN_KEY);
    if (!OPTION_TOOLS_ENABLED) {
      window.location.replace(RoutePath.LOGIN);
      return;
    }

    const returnTo = encodeURIComponent(
      `${window.location.pathname}${window.location.search}`,
    );
    window.location.replace(`${RoutePath.LOGIN}?return_to=${returnTo}`);
  },
});

// Login bootstrap must surface GET /me failures to the login form without the
// shared 401 handler navigating the main frame away first.
export const loginBootstrapApiRequest = new ApiRequest({
  baseUrl: API_ADDRESS,
});
